import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Nav from "../Home/navbar/nav";
import "./Enrol.scss";
import girl from "../Assets/Product/girl.webp";
import { useNavigate } from "react-router-dom";


function Enrol() {
const navigate = useNavigate();

const slides = [
  {
    title: "Key Features",
    desc: [
      "Smart admission dashboard with advanced analytics",
      "Program and course management system",
      "Digital application and document management",
      "Lead tracking and automated follow-ups",
      "Real-time application status updates"
    ]
  },
  {
    title: "Benefits of Enrol",
    desc: [
      "Boost admission conversion rates",
      "Eliminate paperwork completely",
      "Centralized and secure data management",
      "Faster admission processing",
      "Enhanced experience for students and parents"
    ]
  },
  {
    title: "Why Choose Enrol?",
    desc: [
      "Capture every inquiry efficiently",
      "Track every application in real time",
      "Increase student conversion rates",
      "Automate repetitive administrative tasks",
      "Reduce workload by up to 70%"
    ]
  },
  {
    title: "Problems We Solve",
    desc: [
      "Manual paperwork and human errors",
      "Long queues during the admission season",
      "Poor inquiry tracking",
      "Delayed verification processes",
      "Low conversion rates",
      "Lack of centralized data"
    ]
  },
  {
    title: "Who Can Use Enrol?",
    desc: [
      "Colleges",
      "Universities",
      "Institutions handling high admission volumes",
      "Campuses looking to digitize admissions",
      "Organizations aiming to improve conversion rates"
    ]
  }
];
  const [index, setIndex] = useState(1);
  const startX = useRef(0);
  const isDragging = useRef(false);

  const handleMouseDown = (e) => {
  isDragging.current = true;
  startX.current = e.clientX;
};

const handleMouseUp = (e) => {
  if (!isDragging.current) return;

  const diff = e.clientX - startX.current;

  if (diff > 80) {
    prevSlide();
  } else if (diff < -80) {
    nextSlide();
  }

  isDragging.current = false;
};

const handleTouchStart = (e) => {
  startX.current = e.touches[0].clientX;
};

const handleTouchEnd = (e) => {
  const endX = e.changedTouches[0].clientX;
  const diff = endX - startX.current;

  if (diff > 80) {
    prevSlide();
  } else if (diff < -80) {
    nextSlide();
  }
};

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <Helmet>
        <title>Enrol | College Admission Management Software | Althi Solutions</title>
        <meta
          name="description"
          content="Enrol helps colleges capture leads, manage applications, track student progress and increase admission conversions on one centralized platform."
        />
        <link
          rel="canonical"
          href="https://www.althisolutions.com/whatWeDo/Enrol"
        />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="product" />
        <meta
          property="og:title"
          content="Enrol | College Admission Management Software | Althi Solutions"
        />
        <meta
          property="og:url"
          content="https://www.althisolutions.com/whatWeDo/Enrol"
        />
        <meta
          property="og:description"
          content="Enrol helps colleges capture leads, manage applications, track student progress and increase admission conversions on one centralized platform."
        />
        <meta
          property="og:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
        <meta property="og:site_name" content="Althi Solutions" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@AlthiSolutions" />
        <meta
          name="twitter:creator"
          content="@AlthiSolutions"
          />
        <meta
          name="twitter:title"
          content="Enrol | College Admission Management Software | Althi Solutions"
        />
        <meta
          name="twitter:description"
          content="Enrol helps colleges capture leads, manage applications, track student progress and increase admission conversions on one centralized platform."
        />
        <meta
          name="twitter:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
      </Helmet>

      <Nav />
      <section className="enrol">
        <div className="overlay-grid"></div>

        <div className="enrol__container">
          <div className="enrol__left">
            <div className="badge">Enrol</div>

            <h1>
             STREAMLINE ADMISSIONS <br />
             MAXIMIZE ENROLLMENTS <br />
             GO DIGITAL WITH CONFIDENCE.
            </h1>

            <p>
             Enrol helps colleges capture leads, manage applications, track student progress, and increase admission conversions  all in one centralized platform.
            </p>

           <div className="buttons">
            <button
              className="btn primary"
              onClick={() => navigate("/contactus")}
            >
              CONTACT US →
            </button>

            <button
              className="btn outline"
              onClick={() => navigate("/contactus")}
            >
              BOOK A DEMO →
            </button>
          </div>
          </div>

          <div className="enrol__right">
            <div className="circle-bg"></div>
            <img src={girl} alt="admission manager" className="worker" loading="lazy"/>

            <div className="stats-box">
              <h2>70%</h2>
              <p>Less Admin Work</p>
            </div>
          </div>
        </div>
      </section>
      <section className="carousel">
        <h2>TRANSFORM ADMISSIONS WITH ENROL </h2>
        <p>Smart, Automated, and Conversion-Driven Admission Management</p>

        <div className="carousel__wrapper"
  onMouseDown={handleMouseDown}
  onMouseUp={handleMouseUp}
  onMouseLeave={() => (isDragging.current = false)}
  onTouchStart={handleTouchStart}
  onTouchEnd={handleTouchEnd}>
         {slides.map((slide, i) => {
  const total = slides.length;

  const prevIndex = (index - 1 + total) % total;
  const nextIndex = (index + 1) % total;

  let position = "";

  if (i === index) position = "active";
  else if (i === prevIndex) position = "prev";
  else if (i === nextIndex) position = "next";

  return (
    <div key={i} className={`card ${position}`}>
      <div className="text-card">
        <h3>{slide.title}</h3>
        <ul className="points">
  {slide.desc.map((item, idx) => (
    <li key={idx}>{item}</li>
  ))}
</ul>
      </div>
    </div>
  );
})}
        </div>

        <div className="controls">
          <button onClick={prevSlide}>←</button>
          <button onClick={nextSlide}>→</button>
        </div>
      </section>
    </>
  );
}

export default Enrol;